<template>
  <!-- Шапка с параметрами в зависимости от страницы
  Передается: currentRoute = роут для отображения заголовка  -->
  <keep-alive>
    <top-navbar :currentRoute="$route" :filter="false"></top-navbar>
  </keep-alive>

  <section class="container-content orders-container-content">

    <div v-if="isReady && hasResults" class="container-tablist">
      <div class="tablist">
        <div
          v-if="ordersData.length"
          :class="[activeTab === 'orders' ? 'active tab' : 'tab']"
          @click="changeTab('orders')"
        >
          <span>Заказы ({{ ordersData.length }})</span>
          <div class="tab-border-bottom"></div>
        </div>

        <div
          v-if="historyData.length"
          :class="[activeTab === 'history' ? 'active tab' : 'tab']"
          @click="changeTab('history')"
        >
          <span>История заказов ({{ historyData.length }})</span>
          <div class="tab-border-bottom"></div>
        </div>

        <div
          v-if="proposalsData.length"
          :class="[activeTab === 'proposals' ? 'active tab' : 'tab']"
          @click="changeTab('proposals')"
        >
          <span>КП ({{ proposalsData.length }})</span>
          <div class="tab-border-bottom"></div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <section v-if="!isReady" class="absolute-center-block">
        <div class="container-loading">
          <span class="loader loader-default loader-dark"></span>
        </div>
      </section>
    </transition>

    <transition name="fade">
      <section v-if="isReady" class="container-table">

        <table-component
          v-if="hasResults"
          :key="activeTab"
          :currUserID="currUserID"
          :allHeaders="activeAllHeaders"
          :headersDefault="activeHeadersDefault"
          :dataObject="activeData"
          :defaultData="activeDefaultData"
          :type="activeTypePage"
          @sort-table="selectSortField"
          @open-page="openSearchResult"
          @copy-page="copyOrder"
          @edit-page="editOrder"
        ></table-component>

        <div v-else class="empty-orders-notification">
          По вашему запросу ничего не найдено.
        </div>

      </section>
    </transition>

  </section>
</template>

<script>
import TopNavbar from "../components/TopNavbar.vue";
import TableComponent from "../components/TableComponent.vue";
import GlobalRequest from "@/plugins/globalRequest";

export default {
  name: 'SearchPage',
  components: {
    TopNavbar,
    TableComponent
  },
  data() {
    return {
      isReady: false,
      activeTab: '',
      historyStatuses: ['Отменен', 'Отгружен'],
      orderHeadersDefault: {
        id: "ID", 
        orderNumber: "№ Заказа", 
        orderNumberClient: "№ Заказа клиента", 
        created: "Дата создания", 
        total: "Сумма", 
        status: "Статус",
        type: "Тип",
        user: "Пользователь",
        // order_1c_guid
      },
      orderAllHeaders: {
        id: "ID", 
        orderNumber: "№ Заказа",
        orderNumberClient: "№ Заказа клиента", 
        created: "Дата создания", 
        total: "Сумма", 
        status: "Статус",
        type: "Тип",
        user: "Пользователь",
        // order_1c_guid
      },
      proposalHeadersDefault: {
        id: "ID",
        proposalNumber: "№ КП",
        deal: "Наименование проекта",
        validFrom: "Дата КП",
        validTo: "Действует до",
        regions: "Регион доставки"
      },
      proposalAllHeaders: {
        id: "ID",
        proposalNumber: "№ КП",
        deal: "Наименование проекта",
        validFrom: "Дата КП",
        validTo: "Действует до",
        regions: "Регион доставки"
      },
      ordersData: [],
      historyData: [],
      proposalsData: [],
      defaultOrdersData: [],
      defaultHistoryData: [],
      defaultProposalsData: [],
      currUserID: "",
      searchQuery: ""
    }
  },

  computed: {
    hasResults() {
      return this.ordersData.length > 0 || this.historyData.length > 0 || this.proposalsData.length > 0
    },

    activeData() {
      if(this.activeTab === 'history') return this.historyData
      if(this.activeTab === 'proposals') return this.proposalsData
      return this.ordersData
    },

    activeDefaultData() {
      if(this.activeTab === 'history') return this.defaultHistoryData
      if(this.activeTab === 'proposals') return this.defaultProposalsData
      return this.defaultOrdersData
    },

    activeHeadersDefault() {
      return this.activeTab === 'proposals' ? this.proposalHeadersDefault : this.orderHeadersDefault
    },

    activeAllHeaders() {
      return this.activeTab === 'proposals' ? this.proposalAllHeaders : this.orderAllHeaders
    },

    activeTypePage() {
      return this.activeTab === 'proposals' ? 'kp' : 'orderSearch'
    }
  },

  mounted() {
    if(localStorage.getItem('userID') != undefined && localStorage.getItem('userID') != '') {
      this.currUserID = localStorage.getItem('userID')
    }

    this.init();
  },

  methods: {

    // Запрос на фильтрацию
    async getDataFilter(objForRequest) {
      let resultData = []
      let res = await GlobalRequest.request("/order/list/filter", "POST", objForRequest)
      if(res.success)
        resultData = res.data

      return resultData
    },

    async getProposalData() {
      let res = await GlobalRequest.request("/proposal/list", "GET")
      if(res.success)
        return res.data.proposalsList

      return []
    },

    async getData() {
      // Получаем строку поиска
      if(this.$route.query.q ) {
        this.searchQuery = this.$route.query.q 
      }

      let objForRequestOrderNumber = {
        "filter": {
            "orderNumberClient" : {
              "match": "substring",
              "value": this.searchQuery
            }
        }
      };
      
      let objForRequestOrder1cGuid = {
        "filter": {
            "orderNumber" : {
              "match": "substring",
              "value": this.searchQuery
            }
        }
      };

      // Ищем одновременно по номерам заказов и КП
      let [dataOrderNumber, dataOrder1cGuid, proposals] = await Promise.all([
        this.getDataFilter(objForRequestOrderNumber),
        this.getDataFilter(objForRequestOrder1cGuid),
        this.getProposalData()
      ])

      // Объединить
      let orders = dataOrderNumber.concat(dataOrder1cGuid)
        .filter((item, index, self) =>
            index === self.findIndex((t) => (
                t.id === item.id
            ))
        );

      orders.forEach(item => {
        item.type = "Заказ"
      })

      this.ordersData = orders.filter(item => !this.historyStatuses.includes(item.status))
      this.historyData = orders.filter(item => this.historyStatuses.includes(item.status))

      let normalizedSearchQuery = this.searchQuery.toLowerCase()
      this.proposalsData = proposals
        .filter(item => item.proposalNumber.toLowerCase().includes(normalizedSearchQuery))
        .map(item => ({
          ...item,
          validFrom: this.formatDate(item.validFrom),
          validTo: this.formatDate(item.validTo),
          regions: item.regions.length > 0
            ? item.regions.map(region => region.name).join(', ')
            : ''
        }))
    },

    // Инициализация
    async init() {
      this.isReady = false

      await this.getData()

      this.sortByDateDescending(this.ordersData, "created")
      this.sortByDateDescending(this.historyData, "created")
      this.sortByDateDescending(this.proposalsData, "validFrom")

      this.defaultOrdersData = JSON.parse(JSON.stringify(this.ordersData))
      this.defaultHistoryData = JSON.parse(JSON.stringify(this.historyData))
      this.defaultProposalsData = JSON.parse(JSON.stringify(this.proposalsData))

      if(this.ordersData.length > 0)
        this.activeTab = 'orders'
      else if(this.historyData.length > 0)
        this.activeTab = 'history'
      else if(this.proposalsData.length > 0)
        this.activeTab = 'proposals'
      else
        this.activeTab = ''

      this.isReady = true
    },

    sortByDateDescending(data, field) {
      data.sort((a, b) => {
        let fieldA = this.sortingCell(a, field)
        let fieldB = this.sortingCell(b, field)

        if (fieldA > fieldB) return -1
        if (fieldA < fieldB) return 1
        return 0
      })
    },

    formatDate(dateString) {
      const date = new Date(dateString)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      return `${day}.${month}.${year}`
    },

    parseCustomDate(dateStr) {
      const parts = dateStr.split(".");
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);
      return new Date(year, month, day);
    },

    sortingCell(obj, field) {
      let fieldObj = 0
      if(obj[field] != "" && obj[field] != " " && obj[field] != 0 && obj[field] != null) {
        if(field == "orderWeight" || field == "total") {
          fieldObj = parseFloat(obj[field])
        }
        else if(field == "created" || field == "shipmentDate" || field == "validFrom" || field == "validTo") {
          fieldObj = this.parseCustomDate(obj[field])
        }
        else {
          if(typeof obj[field] == "number")
            fieldObj = obj[field]
          else
            fieldObj = obj[field].toString().toLowerCase();
        }
      }
      return fieldObj
    },

    // Выбор поля для сортировки
    selectSortField(newDataObj) {
      if(this.activeTab === 'history')
        this.historyData = newDataObj
      else if(this.activeTab === 'proposals')
        this.proposalsData = newDataObj
      else
        this.ordersData = newDataObj
    },

    changeTab(tabName) {
      this.activeTab = tabName
    },

    openSearchResult(id) {
      if(this.activeTab === 'proposals')
        this.openProposal(id)
      else
        this.openOrder(id)
    },

    // Открыть заказ по id
    editOrder(id) {
      this.$router.push({
          path: '/order/detail',
          query: { id: id, type: 'edit' },
      });
    },

    // Скопировать заказ
    copyOrder(id) {
      this.$router.push({
        path: '/order/create',
        query: { id: id},
      });
    },

    // Открыть заказ по id
    openOrder(id) {
      this.$router.push({
        path: '/order/detail',
        query: { id: id, type: 'view' },
      });
    },

    openProposal(id) {
      this.$router.push({
        path: '/kp/detail',
        query: { id: id },
      });
    },

  }
}
</script>
